import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FundPostStatusEnumType } from '__generated__/graphql';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import ConfirmButton from 'primitives/ConfirmButton';

const REMOVE_FUND_POST_MUTATION = gql(`
  mutation UpdateFundPostStatus($id: ID!, $status: FundPostStatusEnumType!) {
    updateFundPostStatus(id: $id, status: $status) {
      id
      status
      updatedAt
    }
  }
`);

const DeleteFundPostButton: FC<{ id: string }> = ({ id }) => {
  const navigate = useNavigate();

  const [removePost, { loading, error }] = useMutation(REMOVE_FUND_POST_MUTATION, {
    update(cache, { data }) {
      if (!data) return;
      cache.modify({
        fields: {
          fundPosts(existingPostsRef, { readField }) {
            const updatedPostsRef = { ...existingPostsRef };
            updatedPostsRef.nodes = existingPostsRef.nodes.filter(
              PostRef => id !== readField('id', PostRef)
            );
            return updatedPostsRef;
          },
        },
      });
    },
    onCompleted() {
      navigate('/approvals/fund-posts');
    },
  });

  return (
    <ConfirmButton
      onConfirm={() => removePost({ variables: { id, status: FundPostStatusEnumType.Deleted } })}
      loading={loading}
      error={error}
      variant="secondary"
      description="This will delete all data concerning this post."
    >
      Remove
    </ConfirmButton>
  );
};

export default DeleteFundPostButton;
